module.exports = __webpack_public_path__ + "static/media/sidenav2.d906ee95.png";